import BurgerButton from '../modules/burgerButton';

export default {
  init() {
    let menuBurger = new BurgerButton($('[data-trigger-menu]'));

    /**
     * Open Menu
     */
    $(menuBurger.burgerEl).on('burgeropen', () => {
      $('.pop-over-menu').addClass('pop-over-menu--open');
      $('.pop-over-menu li').addClass('stagger-left-to-right');
      $('body').addClass('menu-open');
    });

    /**
     * Close Menu
     */
    $(menuBurger.burgerEl).on('burgerclosed', () => {
      $('.pop-over-menu').removeClass('pop-over-menu--open');
      $('.pop-over-menu li').removeClass('stagger-left-to-right');
      $('body').removeClass('menu-open');
      $(this).removeClass('burger--closed');
    });

     /***
     * Trigger Close event on body click
     */
    $('body').on('click', () => {
      if( $('.pop-over-menu').hasClass('pop-over-menu--open') ){
        $(menuBurger.burgerEl).trigger('click');
      }
    });
  },
}



// WEBPACK FOOTER //
// ./scripts/modules/mobile-menu.js